module.exports = __webpack_public_path__ + "img/barter-light.6536ed37.svg";